import { render, staticRenderFns } from "./ComparisonPoliciesSelectDrawer.vue?vue&type=template&id=39ba6312&scoped=true&"
import script from "./ComparisonPoliciesSelectDrawer.vue?vue&type=script&lang=js&"
export * from "./ComparisonPoliciesSelectDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonPoliciesSelectDrawer.vue?vue&type=style&index=0&id=39ba6312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ba6312",
  null
  
)

export default component.exports